import React from "react";
import NavSide from "../containers/NavSide.jsx";

export default function Data() {
  return (
    <div>
      <div className="w-full flex pt-20 bg-slate-600 min-h-screen">
        <NavSide />
        <div className="ml-44 mt-8 p-4 w-3/12 rounded-lg h-64 text-white">
          Data model is here
        </div>
      </div>
    </div>
  );
}
